import { scrollHandlers } from "lib/scrollHandlers";
import { useEffect } from "react";
import styles from "./auth.module.scss";

type Props = {
   show: boolean;
   onClose: () => void;
   children: React.ReactNode;
};
export default function Component({ show, onClose, children }: Props) {
   useEffect(() => {
      show ? scrollHandlers.lock() : scrollHandlers.unlock();
   }, [show]);

   if (!show) return null;

   return (
      <div className={styles.modal}>
         <button className="screenBackdrop open" onClick={onClose} />

         <div className={styles.content}>
            <div className={styles.header}>
               <div className={styles.siteTitle}>
                  newsbeast{" "}
                  <button className={styles.close} onClick={onClose}>
                     <div dangerouslySetInnerHTML={{ __html: '<svg><use xlink:href="#iconClose" /></svg>' }} />
                  </button>
               </div>
            </div>
            <div className={styles.body}>{children}</div>
         </div>
      </div>
   );
}
